export default "__VITE_ASSET__DPfIdflZ__"